import { CMAPresentationApi, Configuration, RequestContext } from "./generated";

async function preMiddleware(context: RequestContext) {
  context.init.credentials = "include";
  return context;
}

function getConfig() {
  return new Configuration({
    basePath: `${process.env.SIDEKICK_COMPS_API_URL}`,
  });
}

export const getCMAPresentationApi: () => CMAPresentationApi = () => {
  return new CMAPresentationApi(getConfig()).withPreMiddleware(preMiddleware);
};
